<template>
  <v-btn @click="$emit('click', $event)">
    <v-icon>mdi-arrow-up-thick</v-icon>
    戻る
  </v-btn>
</template>

<script>
  export default {
    name: 'BackBtn',
    components: {
    },
    methods: {
    },
  }
</script>
